import type { FaireProductEntity } from "../../entity_types/product";

export const p_5fp6zhy54z: FaireProductEntity = {
  token: "p_5fp6zhy54z",
  type: "product",
  name: "CZ & Rhinestone Rectangle Gold Dip Stud Earrings",
  brandToken: "b_k2cxrcr92s",
  brandName: "Frem",
  imageUrl:
    "https://cdn.faire.com/fastly/a1548f719cdef0c7a431785198ab3d21e03fbee5f414f68ef1596eccc0063773.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0321043cf16a5f617ce3b90c3f8094e959a7fe45f46dfda6ba31dcf8d1e47624.jpeg",
    "https://cdn.faire.com/fastly/59056df132e1cfdd4b38a5caeba136fabab732607b5324f073a82c4f1aed0b65.jpeg",
    "https://cdn.faire.com/fastly/5ee3b63d2ce4f6c7443ffad4ff3c0a8bbb9164ae22a252dd04cb898147005ea2.jpeg",
  ],
  priceDollars: 6.93,
  description:
    "Effortlessly elevate any outfit with our CZ &amp; Rhinestone Rectangle Gold Dip Stud Earrings. These stunning earrings feature a minimalist design with cubic zirconia and rhinestones, adding a touch of glamour to your look. Perfect for any occasion, these earrings are a must-have addition to your jewelry collection.",
  tags: [],
  msrpDollars: 20.79,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:08.371Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
